<script setup></script>
<template>
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3490_10358)">
      <circle cx="51.8615" cy="49.7033" r="47.7033" fill="white" />
      <circle
        cx="51.8615"
        cy="49.7033"
        r="45.7033"
        stroke="url(#paint0_linear_3490_10358)"
        stroke-width="4"
      />
    </g>
    <path
      d="M71.528 41.5477H49.8031L47.5725 36.6931H48.0089C48.5423 36.6931 48.9788 36.2561 48.9788 35.7221V30.8674C48.9788 30.3334 48.5423 29.8965 48.0089 29.8965H36.3706C35.8371 29.8965 35.4007 30.3334 35.4007 30.8674V35.7221C35.4007 36.2561 35.8371 36.6931 36.3706 36.6931H36.807L32.1032 46.985C32.1032 47.0336 32.1032 47.0336 32.0547 47.0821C32.0547 47.1306 32.0547 47.1306 32.0547 47.1792C32.0547 47.2277 32.0547 47.2277 32.0547 47.2763C32.0547 47.3248 32.0547 47.3734 32.0547 47.3734V69.705C32.0547 70.239 32.4911 70.6759 33.0245 70.6759H49.6092C50.5305 72.4236 52.3733 73.5887 54.4585 73.5887H55.4768C56.2527 73.5887 57.0286 73.4431 57.756 73.1033C58.4834 73.3945 59.2108 73.5887 60.0352 73.5887H61.0535C63.1872 73.5887 65.03 72.4236 65.9028 70.6759H71.625C72.1584 70.6759 72.5949 70.239 72.5949 69.705V49.7036C74.3891 49.2667 75.7469 47.6161 75.7469 45.6742C75.6499 43.3925 73.8072 41.5477 71.528 41.5477ZM37.3404 31.8384H47.039V34.7512H37.3404V31.8384ZM50.4336 60.7723C49.5122 61.7433 48.9788 63.0055 48.9788 64.3648V68.2486C48.9788 68.3942 48.9788 68.5884 48.9788 68.734H33.9459V52.8592L36.3706 51.6941L36.4676 51.6455C37.5829 51.1115 38.7952 50.9173 40.0075 51.1115C40.638 51.2086 41.2199 51.3542 41.8018 51.6455C44.0325 52.7135 46.5541 52.7135 48.7848 51.6455L50.482 50.8202V60.7723H50.4336ZM50.4336 48.6841L48.0089 49.8493L47.9119 49.8978C46.7966 50.4318 45.5842 50.626 44.3719 50.4318C43.7415 50.3347 43.1596 50.1891 42.5777 49.8978C40.347 48.8298 37.8254 48.8298 35.5947 49.8978L33.9459 50.6746V47.5676L34.0429 47.3734L38.9407 36.6931H45.4388L50.3366 47.3734L50.4336 47.5676V48.6841ZM64.4965 68.2486C64.4965 70.1419 62.8963 71.6468 60.9565 71.6468H59.9382C59.3078 71.6468 58.6774 71.5012 58.144 71.1614C57.9985 71.0643 57.853 71.0643 57.659 71.0643C57.465 71.0643 57.3196 71.1128 57.1741 71.1614C56.6407 71.4527 56.0103 71.6468 55.3798 71.6468H54.3615C52.4218 71.6468 50.8215 70.1419 50.8215 68.2486V64.3648C50.8215 62.4715 52.4218 60.9665 54.3615 60.9665H55.3798C55.8163 60.9665 56.2527 61.0636 56.6892 61.2093V62.4229C56.6892 62.9569 57.1256 63.3939 57.659 63.3939C58.1924 63.3939 58.6289 62.9569 58.6289 62.4229V61.2093C59.0168 61.0636 59.4533 60.9665 59.9382 60.9665H60.9565C62.8963 60.9665 64.4965 62.4715 64.4965 64.3648V68.2486ZM71.528 47.8588C70.9946 47.8588 70.5582 48.2958 70.5582 48.8298V68.734H66.4363C66.4363 68.5884 66.4363 68.3942 66.4363 68.2486V64.3648C66.4363 61.4034 63.9631 59.0246 60.9565 59.0246H59.9382C59.5018 59.0246 59.0653 59.0732 58.6289 59.1703V58.0537C58.6289 56.9857 59.5018 56.1118 60.5686 56.1118C61.102 56.1118 61.5385 55.6749 61.5385 55.1409C61.5385 54.6069 61.102 54.17 60.5686 54.17C58.4349 54.17 56.6892 55.9176 56.6892 58.0537V59.1703C56.2527 59.0732 55.8163 59.0246 55.3798 59.0246H54.3615C53.6341 59.0246 52.9067 59.1703 52.2763 59.413V47.3734C52.2763 47.3248 52.2763 47.3248 52.2763 47.2763C52.2763 47.2277 52.2763 47.2277 52.2763 47.1792C52.2763 47.1306 52.2763 47.1306 52.2763 47.0821C52.2763 47.0336 52.2763 47.0336 52.2278 46.985L50.676 43.4896H71.528C72.7404 43.4896 73.7102 44.4606 73.7102 45.6742C73.7102 46.8879 72.7404 47.8588 71.528 47.8588ZM42.1897 55.1409C39.7651 55.1409 37.8254 57.0828 37.8254 59.5101C37.8254 61.9375 39.7651 63.8793 42.1897 63.8793C44.6144 63.8793 46.5541 61.9375 46.5541 59.5101C46.5541 57.0828 44.6144 55.1409 42.1897 55.1409ZM42.1897 61.9375C40.8319 61.9375 39.7651 60.8694 39.7651 59.5101C39.7651 58.1508 40.8319 57.0828 42.1897 57.0828C43.5475 57.0828 44.6144 58.1508 44.6144 59.5101C44.6144 60.8694 43.5475 61.9375 42.1897 61.9375Z"
      fill="url(#paint1_linear_3490_10358)"
    />
    <defs>
      <filter
        id="filter0_d_3490_10358"
        x="0.158203"
        y="0"
        width="107.406"
        height="107.406"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3490_10358"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3490_10358"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3490_10358"
        x1="99.5649"
        y1="57.1325"
        x2="5.07389"
        y2="66.4344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3490_10358"
        x1="50.8225"
        y1="17.5832"
        x2="88.5801"
        y2="27.0226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped></style>
